import apiRequest from './index'

export default {
  path: '/v1/inspection',
  inspectionPostPath: '/v2/inspection',

  async get (id) {
    await window.callNativeHTTPX()
    return apiRequest.get(`${this.path}?ts_id=${id}`, {
      headers: {
        'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
        'HTTP-X-DAPP-USERID': window.DAPP_USERID,
        'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD
      }
    })
  },

  async getDetail (id) {
    await window.callNativeHTTPX()
    return apiRequest.get(`${this.path}/${id}`, {
      headers: {
        'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
        'HTTP-X-DAPP-USERID': window.DAPP_USERID,
        'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD
      }
    })
  },

  async post (data) {
    await window.callNativeHTTPX()
    console.log('*** call API inspectionpostAPI ***')
    console.log(data)
    return apiRequest.post(this.inspectionPostPath, { ...data }, {
      headers: {
        'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
        'HTTP-X-DAPP-USERID': window.DAPP_USERID,
        'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD
      }
    })
  },

  async changePyingCash (id) {
    await window.callNativeHTTPX()
    console.log(window.DAPP_REQUESTTIME)
    return apiRequest.put(`${this.path}/${id}/change_paying_cash`, {}, {
      headers: {
        'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
        'HTTP-X-DAPP-USERID': window.DAPP_USERID,
        'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD
      }
    })
  }
}
